export default function PrivacyPolicy() {
  const policies = [
    {
      title: 'Information We Collect',
      content: 'ZALETELJ VPN operates under a strict zero-logs policy. We do not collect, store, or monitor your browsing activity, connection logs, IP addresses, traffic data, or DNS queries. We only collect minimal information necessary for account creation, such as your email address for authentication purposes.'
    },
    {
      title: 'How We Use Your Information',
      content: 'The limited information we collect is used solely for account management, customer support, and service improvement. We never sell, rent, or share your personal information with third parties for marketing purposes. Your email address is used only for account-related communications and important service updates.'
    },
    {
      title: 'Data Security',
      content: 'We implement industry-leading security measures to protect your data. All connections are encrypted using military-grade AES-256 encryption. Our infrastructure is designed with security-first principles, and we regularly conduct security audits to ensure the highest level of protection for our users.'
    },
    {
      title: 'No Activity Logs',
      content: 'We do not keep any logs of your online activities. This means we cannot provide information about your browsing history, downloaded files, or accessed websites to anyone, including government agencies or law enforcement, because we simply do not have this information.'
    },
    {
      title: 'Third-Party Services',
      content: 'ZALETELJ VPN does not integrate with third-party tracking or analytics services that could compromise your privacy. We do not use cookies for tracking purposes. Any third-party services we use are carefully vetted to ensure they meet our strict privacy standards.'
    },
    {
      title: 'Your Rights',
      content: 'You have the right to access, modify, or delete your account information at any time. You can request a copy of the limited data we hold about you or permanently delete your account through our support team. We are committed to transparency and will always respect your privacy rights.'
    },
    {
      title: 'Data Retention',
      content: 'We retain your account information only for as long as your account is active. If you delete your account, all associated data is permanently removed from our systems within 30 days. We do not retain any connection logs or activity data at any time.'
    },
    {
      title: 'Changes to This Policy',
      content: 'We may update this privacy policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any significant changes via email. Your continued use of ZALETELJ VPN after such changes constitutes acceptance of the updated policy.'
    }
  ];

  return (
    <section id="privacy" className="py-20 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-1.5 bg-cyan-100 rounded-full">
            <span className="text-cyan-600 text-xs font-semibold uppercase tracking-wider">Your Privacy Matters</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Privacy Policy
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            At ZALETELJ d.o.o., we are committed to protecting your privacy. This policy explains how we handle your data and maintain our zero-logs commitment.
          </p>
          <p className="text-sm text-gray-500 mt-4">Last updated: January 2025</p>
        </div>

        <div className="bg-white rounded-3xl p-10 md:p-12 shadow-lg mb-10">
          <div className="space-y-10">
            {policies.map((policy, index) => (
              <div key={index} className="border-b border-gray-200 last:border-0 pb-8 last:pb-0">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-start gap-3">
                  <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-gradient-to-br from-cyan-500 to-purple-600 text-white rounded-lg text-sm font-bold">
                    {index + 1}
                  </span>
                  {policy.title}
                </h3>
                <p className="text-gray-600 leading-relaxed ml-11">{policy.content}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-gradient-to-br from-cyan-500 to-purple-600 rounded-3xl p-10 text-white shadow-xl">
          <div className="flex items-start gap-6">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl flex-shrink-0">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <div>
              <h3 className="text-2xl font-bold mb-3">Our Privacy Commitment</h3>
              <p className="text-white/90 leading-relaxed mb-6">
                We believe privacy is a fundamental right. Our zero-logs policy is not just a promise—it's built into the core of our service. We cannot provide what we do not collect. Your trust is our most valuable asset, and we work every day to earn and maintain it.
              </p>
              <button
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-6 py-3 bg-white text-cyan-600 font-bold rounded-xl hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
              >
                Contact Us About Privacy
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
